export const HIDDEN_COLUMNS_STORAGE_KEY = "neeto-molecules-hidden-columns";
export const COLUMNS_ORDER_STORAGE_KEY = "neeto-molecules-columns-order";
export const TABLE_CONFIGURATION_QUERY_KEY = "table-configuration";
